// utils/shouldCaptureISTCamera.js
export function shouldCaptureISTCamera(session, currentIndex) {
  if (!session) return false
  if (session.captured.includes(currentIndex)) return false
  return session.targets.includes(currentIndex)
}
